export default "__VITE_ASSET__CGZTOt4K__"